import { render, staticRenderFns } from "./ModularIndexPage.vue?vue&type=template&id=330ce90f&scoped=true"
import script from "./ModularIndexPage.vue?vue&type=script&lang=js"
export * from "./ModularIndexPage.vue?vue&type=script&lang=js"
import style0 from "./ModularIndexPage.vue?vue&type=style&index=0&id=330ce90f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "330ce90f",
  null
  
)

export default component.exports